import { render, staticRenderFns } from "./HealthRecordAdd.vue?vue&type=template&id=12868f7a&scoped=true&"
import script from "./HealthRecordAdd.vue?vue&type=script&lang=js&"
export * from "./HealthRecordAdd.vue?vue&type=script&lang=js&"
import style0 from "./HealthRecordAdd.vue?vue&type=style&index=0&lang=css&"
import style1 from "./HealthRecordAdd.vue?vue&type=style&index=1&id=12868f7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12868f7a",
  null
  
)

export default component.exports